import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class IFrameAPI extends ComponentAPI {
    getAllowOptions() {
        return this.state.allowOptions;
    }
    setAllowOptions(allowOptions) {
        this.setState({ allowOptions });
    }
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
    getEndpoint() {
        return this.state.endpoint;
    }
    setEndpoint(endpoint) {
        this.setState({ endpoint });
    }
    getHeight() {
        return this.state.height;
    }
    setHeight(height) {
        this.setState({ height });
    }
    getSandboxOptions() {
        return this.state.sandboxOptions;
    }
    setSandboxOptions(sandboxOptions) {
        this.setState({ sandboxOptions });
    }
    getWidth() {
        return this.state.width;
    }
    setWidth(width) {
        this.setState({ width });
    }
}
export default IFrameAPI;
//# sourceMappingURL=iframe-api.js.map